import React from "react";

import { Button } from "../../../common/u1/Button";
import { InfoIcon } from "../../../../assets/ui/icons";
import { EditSectionLayout } from "./EditSectionLayout";
import { EditFooterBar } from "./EditFooterBar";

/* A section whose new design has not landed yet.
 *
 * TIP-644 is being uplifted section by section, and this route is a preview
 * (/u1/edit/:id) sitting beside the live /edit/:id — so an un-uplifted section
 * says so and offers the working screen, rather than rendering a half-built
 * form or, worse, nothing at all. Every one of these disappears as its stage
 * lands.
 *
 * It shares the section frame so the shell's layout is identical either way:
 * same header, same pinned footer, no jump when moving onto one of these.
 */
export const SectionPlaceholder = ({
  title,
  companyId,
  header,
  onBack,
  onSkip,
  className = "",
}) => (
  <EditSectionLayout
    className={className}
    header={header}
    footer={
      /* One action, not two. There is nothing to save here, so an earlier cut wired BOTH "Skip for now" and the primary button to onSkip — two controls, same... */
      <EditFooterBar onBack={onBack} onContinue={onSkip} continueLabel="Next section" />
    }
  >
    <h2 className="m-0 text-[16px] font-bold text-[var(--ink)] font-sans">
      {title}
    </h2>

    <div className="mt-3.5 rounded-[14px] border border-dashed border-[var(--line-2)] bg-white px-4 py-10 text-center sm:px-6">
      <span
        aria-hidden="true"
        className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-[var(--line)] bg-[var(--bg)] text-[var(--muted-2)]"
      >
        <InfoIcon size={18} />
      </span>

      <p className="mx-auto mb-0 mt-3 max-w-[380px] text-[13.5px] leading-[1.55] text-[var(--muted)] font-sans">
        The new design for <b className="font-semibold text-[var(--ink-2)]">{title}</b>{" "}
        is still to come. Its form is unchanged and works on the current screen.
      </p>

      {companyId && (
        <Button
          variant="outline"
          className="mt-4"
          onClick={() => {
            /* A full navigation, not a router push: the live screen is a
               different shell, and this preview must not try to host it. */
            window.location.assign(`/edit/${companyId}`);
          }}
        >
          Open on the current screen
        </Button>
      )}
    </div>
  </EditSectionLayout>
);

export default SectionPlaceholder;
